/* eslint-disable max-lines */

import { REQUIRED_PROPERTIES } from '../components/environments/actions/add-data-sources/df-util';

const dsNodes = [
  {
    type: 'vc',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dvSwitchList',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'nsx',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'vCenterIp',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'nsxt',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'velocloud',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'vcentercloud',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dvSwitchList',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'policymanager',
    properties: [
      'proxyIP',
      'vCenterIp',
      'dsIp',
      'refreshToken',
      'dsNickname',
      'dsNotes',
      'dfwIpfix'
    ]
  },
  {
    type: 'aws',
    properties: [
      'proxyIP',
      'accessKey',
      'secretKey',
      'dsEnableFlows',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'azure',
    properties: [
      'proxyIP',
      'dsAzureTenant',
      'dsAzureClient',
      'dsAzureKey',
      'dsAzureSubsciption',
      'dsEnableFlows',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'pks',
    properties: [
      'dsManagerIp',
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'kubernetes',
    properties: [
      'dsManagerIp',
      'proxyIP',
      'kubeconfig',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'openshift',
    properties: [
      'dsManagerIp',
      'proxyIP',
      'kubeconfig',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'pan',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'checkpoint',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'fortinet',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'ciscoucs',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'snmpEnabled',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'hpvirtualconnect',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'hponeview',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'switch',
    properties: [
      'switchType',
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'huawei',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'genericswitch',
    properties: [
      'proxyIP',
      'configFileLocation',
      'dsIp',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'dellos',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'ciscoaci',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'flowphysical',
    properties: ['proxyIP', 'dsNickname', 'dsNotes']
  },
  {
    type: 'infobloxdns',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'bigip',
    properties: [
      'proxyIP',
      'dsIp',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes'
    ]
  },
  {
    type: 'snow',
    properties: [
      'proxyIP',
      'dsUsername',
      'dsPassword',
      'dsNickname',
      'dsNotes',
      'dsInstanceId',
      'dsGraphConfig',
      'isDsGraphConfigCustomized'
    ]
  }
];

export const vrniDSNodesDisplayMetadata = dsNodes.reduce((acc, cur) => {
  return {
    ...acc,
    [cur.type]: cur.properties.map(name => ({
      name,
      validationRules: REQUIRED_PROPERTIES.includes(name)
        ? [
            {
              name: 'required'
            }
          ]
        : [],
      displayRules: [],
      order:
        REQUIRED_PROPERTIES.indexOf(name) < 0
          ? 10
          : REQUIRED_PROPERTIES.indexOf(name)
    }))
  };
}, {});
